// extracted by mini-css-extract-plugin
module.exports = {"root":"IconMap_root__1LttO"};